import { queryOptions } from '@tanstack/react-query';
import { meetingKeys } from '@shared/api/query-keys';
import type { GetMeetingsParams } from '@/api';
import { meetingsApi } from './meetings';

type Id = string | number;

/**
 * Co-located `queryOptions` for the meetings domain (Server-state rebuild, P4).
 * Key + queryFn defined once; hooks add per-call overrides (`enabled`).
 */
export const meetingQueries = {
  list: (auditId?: string, params?: GetMeetingsParams) =>
    queryOptions({
      queryKey: meetingKeys.list(auditId, params),
      queryFn: () => meetingsApi.getMeetings(auditId as string, params),
    }),
  allForAudit: (auditId?: string) =>
    queryOptions({
      queryKey: meetingKeys.allForAudit(auditId),
      queryFn: () => meetingsApi.getAllMeetings(auditId as string),
    }),
  detail: (auditId?: string, meetingId?: Id) =>
    queryOptions({
      queryKey: meetingKeys.detail(auditId, meetingId),
      queryFn: () => meetingsApi.getMeeting(auditId as string, meetingId as Id),
    }),
};
